import { makeStyles, Theme } from '@material-ui/core';

import { PALETTE_ERROR_MAIN } from 'utils/colours';
const useStyles = makeStyles((theme: Theme) => ({
  container: {
    padding: theme.spacing(1, 2),
    '& .MuiIconButton-label': {
      columnGap: theme.spacing(0.5),
    },
  },
  icon: {
    color: PALETTE_ERROR_MAIN,
  },
  text: {
    color: PALETTE_ERROR_MAIN,
  },
}));
export default useStyles;
